import { gql } from "@apollo/client";

const GET_TAGS = gql`
  query GetTags($category: TagCategory!, $filters: TagFilter, $orderBy: TagOrderBy, $paginationInfo: PaginationInfo) {
    tags(category: $category, filters: $filters, orderBy: $orderBy, paginationInfo: $paginationInfo) {
      totalCount
      currentPage
      perPage
      currentOffset
      nodes {
        id
        name
        category
        enabled
        taggingsCount
      }
    }
  }
`;

export { GET_TAGS };
